/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VolunteerAssignedClientResponse
 */
export interface VolunteerAssignedClientResponse {
    /**
     * 
     * @type {string}
     * @memberof VolunteerAssignedClientResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerAssignedClientResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerAssignedClientResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerAssignedClientResponse
     */
    caseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof VolunteerAssignedClientResponse
     */
    status: string | null;
    /**
     * 
     * @type {Date}
     * @memberof VolunteerAssignedClientResponse
     */
    assignedAtUtc: Date;
}

/**
 * Check if a given object implements the VolunteerAssignedClientResponse interface.
 */
export function instanceOfVolunteerAssignedClientResponse(value: object): value is VolunteerAssignedClientResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('caseNumber' in value) || value['caseNumber'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('assignedAtUtc' in value) || value['assignedAtUtc'] === undefined) return false;
    return true;
}

export function VolunteerAssignedClientResponseFromJSON(json: any): VolunteerAssignedClientResponse {
    return VolunteerAssignedClientResponseFromJSONTyped(json, false);
}

export function VolunteerAssignedClientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolunteerAssignedClientResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'caseNumber': json['caseNumber'],
        'status': json['status'],
        'assignedAtUtc': (new Date(json['assignedAtUtc'])),
    };
}

export function VolunteerAssignedClientResponseToJSON(json: any): VolunteerAssignedClientResponse {
    return VolunteerAssignedClientResponseToJSONTyped(json, false);
}

export function VolunteerAssignedClientResponseToJSONTyped(value?: VolunteerAssignedClientResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'caseNumber': value['caseNumber'],
        'status': value['status'],
        'assignedAtUtc': value['assignedAtUtc'].toISOString(),
    };
}

